
import {createAsyncThunk} from '@reduxjs/toolkit'
import {getBranchservicetype} from 'sr/utils/api/masterData/branchservicetype/getBranchservicetype'
export const fetchbranchservicetype = createAsyncThunk(
  'getBranchservicetype',
  async () => {
    const response = await getBranchservicetype()
    return response?.data
  }
)


